import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useHeader } from "../../contexts/HeaderContext";
import { Default } from "../../components/default/Default";
import { CollectionsTable, SupplierFilter } from "../../components/collections/Table";
import { AddCollection } from "../../components/collections/AddCollection";

import "./collections.css";

export const Collections = () => {
  const { showCollection, handleShowCollection, handleCloseCollection } =
    useHeader();
  const [supplier, setSupplier] = useState("all");

  // /collections/:id opens the edit drawer for that collection. The route IS the
  // trigger — the table's "Edit collection" action navigates here.
  const { id } = useParams();
  const navigate = useNavigate();
  const collectionList = useSelector(
    (state) => state.collectionReducer.collectionList || []
  );
  const editCollection = id
    ? collectionList.find((c) => String(c.id) === String(id)) || {}
    : {};

  return (
    <Default>
      <div className="mca-content">
        {/* Page header with title, subtitle, and controls */}
        <div className="col-head">
          <div>
            <h1 style={{ fontSize: "26px", fontWeight: "700", letterSpacing: "-0.02em" }}>
              Collections
            </h1>
            <p style={{ color: "var(--mca-muted)", fontSize: "14px", margin: "6px 0 0" }}>
              Schedule and run recurring API batches across Amazon, Officeworks, and Repco.
            </p>
          </div>
          <div className="mca-page-actions">
            <SupplierFilter value={supplier} onChange={setSupplier} />
            <button
              className="mca-btn mca-btn--primary"
              onClick={handleShowCollection}
              type="button"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 5v14M5 12h14" />
              </svg>
              <span className="mca-btn__label">Add Collection</span>
            </button>
          </div>
        </div>

        {/* Collections table and bulk bar */}
        <CollectionsTable supplierFilter={supplier} />
      </div>

      {/* Add / Edit Collection drawer */}
      <AddCollection
        show={showCollection}
        handleClose={handleCloseCollection}
        activeCollection={editCollection}
        activeModal={id || false}
        setActiveModal={(value) => {
          // CollectionForm closes edit mode by calling setActiveModal(false);
          // navigate back to the list so the drawer (open on :id) closes.
          if (!value) navigate("/collections");
        }}
      />
    </Default>
  );
};
